import { render, staticRenderFns } from "./Havale.vue?vue&type=template&id=2b4b05ae&"
import script from "./Havale.vue?vue&type=script&lang=js&"
export * from "./Havale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports